// HTMLFormElement.prototype.requestSubmit for Safari before 16. The warehouse's iPod touches
// (7th gen) stop at iOS 15, and Turbo 8 dropped the copy of this polyfill that Turbo 7 shipped,
// so every requestSubmit() call (the admin scanner pages, checkout) threw there. Same behavior
// as the native method: validation runs and a submit event fires, which form.submit() skips.
(function (prototype) {
  if (typeof prototype.requestSubmit === "function") return

  prototype.requestSubmit = function (submitter) {
    if (submitter) {
      validateSubmitter(submitter, this)
      submitter.click()
    } else {
      submitter = document.createElement("input")
      submitter.type = "submit"
      submitter.hidden = true
      this.appendChild(submitter)
      submitter.click()
      this.removeChild(submitter)
    }
  }

  function validateSubmitter(submitter, form) {
    if (!(submitter instanceof HTMLElement)) raise(TypeError, "parameter 1 is not of type 'HTMLElement'")
    if (submitter.type !== "submit") raise(TypeError, "The specified element is not a submit button")
    if (submitter.form !== form) raise(DOMException, "The specified element is not owned by this form element", "NotFoundError")
  }

  function raise(errorConstructor, message, name) {
    throw new errorConstructor(`Failed to execute 'requestSubmit' on 'HTMLFormElement': ${message}.`, name)
  }
})(HTMLFormElement.prototype)
